import styled from 'styled-components';

export const StyledStarRating = styled.div`
  &.star-rating-wrapper {
    .ant-form-item {
      width: 100%;
      margin: 10px 0;

      .ant-form-item-row {
        display: flex;
        justify-content: space-between;
      }

      .ant-form-item-label {
        flex: 0 0 auto;
      }

      .ant-form-item-control {
        flex: 0 0 auto;
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  .ant-rate {
    color: ${(props) => props.theme.ratingStarColor};
    font-size: 24px;

    .ant-rate-star {
      margin-right: 8px;
    }

    .ant-rate-star-zero {
      .anticon {
        color: ${(props) => props.theme.startRatingBase};
      }
    }
  }
`;